import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import {useDispatch} from "react-redux";
import {useHistory} from "react-router-dom";
import {useSnackbar} from "notistack";
import {checkTokenAvailability} from "../../../../common/utils/utils";
import {logout} from "../../../../redux/actions";
import {getAllHospices} from "../../../utils/helpers/dataGetter";
import Typography from "@material-ui/core/Typography";
import {componentTitles} from "../../../../constants/names/titles";
import MaterialTable from "material-table";
import CustomSelect from "./customSelect";

export default function PaceHospices(props) {

    const columns = [
        {title: 'Hospice Name', field: 'hospice_name', width: 600, editable:'never', defaultSort:'asc'},
        {title: 'Is in PACE program', field: 'ispace', width: 200, sorting:false, headerStyle:{textAlign: 'center'},
            render: rowData => {
                return(
                    <CustomSelect rowData={rowData} updateView={updateView}/>
                )
            }
        },
    ];

    const [manufacturers, setManufacturers] = useState([]);
    const dispatch = useDispatch();
    const history = useHistory();
    const {enqueueSnackbar} = useSnackbar();
    useEffect(() => {
        (async () => {
            const availableToken = await checkTokenAvailability();
            if (!availableToken) {
                dispatch(logout());
                history.push('/login');
            }
        })();
        getAllHospices(setManufacturers)
    }, []);

    const updateView = () => {
        getAllHospices(setManufacturers)
    };

    return (
        <React.Fragment>
            <Grid container justify={"center"} alignItems={"center"} direction={"column"} style={{paddingTop: 24}}>
                <Grid item>
                    <Typography variant={"h6"} style={{paddingBottom: 12}}>
                        {componentTitles.paceHospices}
                    </Typography>
                </Grid>
                <Grid item>
                    <MaterialTable
                        title={componentTitles.paceHospices}
                        columns={columns}
                        data={manufacturers}
                        options={{
                            pageSize: 20,
                        }}

                        />
                </Grid>
            </Grid>
        </React.Fragment>
    )
};